import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

interface Props {
  open: boolean
  onAccept: (file: string) => void
  onReject: () => void
  isSubmitting?: boolean
}

const UploadInvoiceModal: React.FC<Props> = ({ open, onReject, onAccept, isSubmitting = false }) => {
  const [file, setFile] = useState('')

  useEffect(() => {
    if (!open && !isSubmitting) {
      setFile('')
    }
  }, [isSubmitting, open])

  return (
    <Dialog
      open={open}
      onClose={isSubmitting ? undefined : onReject}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Carga la cuenta de cobro firmada</DialogTitle>
      <DialogContent>
        <p>La cuenta de cobro debe ser firmada y adjuntada aquí:</p>
        <TextField
          label="URL a cuenta de cobro"
          variant="outlined"
          margin="normal"
          value={file}
          onChange={event => setFile(event.target.value)}
          disabled={isSubmitting}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => onAccept(file)}
          color="primary"
          variant="contained"
          disabled={file?.length <= 6 || isSubmitting}
        >
          {isSubmitting ? 'Guardando...' : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UploadInvoiceModal
